module.exports = __webpack_public_path__ + "static/cheap-ceb58f30f5b7c2df729a47eaeb41a299.svg";